import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Home from 'views/Home';
import NotFound from 'views/NotFound';

import PageLoader from 'shared/components/PageLoader';

const TagGeneratorView = lazy(() => import('views/TagGeneratorView'));
const VideoManagerView = lazy(() => import('views/VideoManagerView'));
const ImagesGalleryView = lazy(() => import('views/ImagesGalleryView'));
const SlugGeneratorView = lazy(() => import('views/SlugGeneratorView'));

function IndexRouter() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={<Home />}
        />
        <Route
          path="tag-generator"
          element={
            <Suspense fallback={<PageLoader />}>
              <TagGeneratorView />
            </Suspense>
          }
        />
        <Route
          path="video-manager"
          element={
            <Suspense fallback={<PageLoader />}>
              <VideoManagerView />
            </Suspense>
          }
        />
        <Route
          path="images-gallery"
          element={
            <Suspense fallback={<PageLoader />}>
              <ImagesGalleryView />
            </Suspense>
          }
        />
        <Route
          path="slug-generator"
          element={
            <Suspense fallback={<PageLoader />}>
              <SlugGeneratorView />
            </Suspense>
          }
        />
        <Route
          path="*"
          element={<NotFound />}
        />
      </Routes>
    </Router>
  );
}

export default IndexRouter;
